import React from 'react'
import ChevronRightIcon from '../../../assets/icons/ChevronRightIcon'
import CheckIcon from '../../../assets/icons/CheckIcon'

/*
 * A row in a dropdown menu, laid out the way the sheet draws one: an icon in a
 * fixed slot on the left, the label, and then whatever belongs at the far right
 * - a keyboard shortcut, a check on the chosen row, a chevron when the row
 * opens a menu of its own.
 *
 * Every one of those is optional, and a caller that passes nothing but children
 * gets what it got before, so the rows that still build their own <div> with an
 * icon inside keep working.
 */
const DropdownMenuItem = ({
                              children,
                              onClick,
                              id,
                              icon = null,
                              shortcut = null,
                              selected = false,
                              hasSubmenu = false,
                              danger = false,
                              disabled = false,
                              style = {},
                              className = '',
                          }) => {
    const classes = ['dropdown-item']
    if (danger) classes.push('danger')
    if (selected) classes.push('selected')
    if (disabled) classes.push('disabled')
    if (className) classes.push(className)

    return (
        <div
            id={id}
            className={classes.join(' ')}
            onClick={e => {
                if (disabled) {
                    e.stopPropagation()
                    return
                }
                onClick(e)
            }}
            style={{...style}}
        >
            {icon && <span className="dropdown-item__icon">{icon}</span>}

            <span className="dropdown-item__label">{children}</span>

            {shortcut && <span className="dropdown-item__shortcut">{shortcut}</span>}

            {selected && (
                <CheckIcon
                    className="dropdown-item__check"
                    width={16}
                    height={16}
                    stroke="currentColor"
                />
            )}

            {hasSubmenu && (
                <ChevronRightIcon
                    className="dropdown-item__chevron"
                    width={16}
                    height={16}
                    stroke="currentColor"
                />
            )}
        </div>
    )
}

export default DropdownMenuItem



// WEBPACK FOOTER //
// ./src/components-new/ui/DropdownMenu/DropdownMenuItem.jsx